import { TabContext } from "../context/TabContext";
import React from "react";

export const useTabContext = () => React.useContext(TabContext);
